import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  shapes: [],
  selectedIds: [],
  inProgress: null,
};

const drawingSlice = createSlice({
  name: 'drawing',
  initialState,
  reducers: { 
    addShape(state, { payload }) { 
      state.shapes.push(payload);
    },

    updateShape(state, { payload }) {
      
      const idx = state.shapes.findIndex((s) => s.id === payload.id);
      if (idx === -1) return;
      const shape = state.shapes[idx];
      
      if (payload.geometry) shape.geometry = payload.geometry;
      
      if (payload.properties)
        shape.properties = { ...shape.properties, ...payload.properties };
    },

    removeShapes(state, { payload }) { 
      const ids = Array.isArray(payload) ? payload : [payload];
      state.shapes = state.shapes.filter((s) => !ids.includes(s.id));
      state.selectedIds = state.selectedIds.filter((id) => !ids.includes(id));
    },
 
    setAllShapes(state, { payload: shapes }) {
      state.shapes     = shapes;
      state.selectedIds = [];
    },

    clearAllShapes(state) {
      state.shapes      = [];
      state.selectedIds = [];
      state.inProgress  = null;
    },
 
    setSelectedIds(state, { payload }) { 
      state.selectedIds = payload;
    },

    toggleSelectedId(state, { payload }) { 
      const exists = state.selectedIds.includes(payload);
      state.selectedIds = exists
        ? state.selectedIds.filter((id) => id !== payload)
        : [...state.selectedIds, payload];
    },

    clearSelection(state) {
      state.selectedIds = [];
    },
 
    updateSelectedShapes(state, { payload }) { 
      state.shapes = state.shapes.map((s) =>
        state.selectedIds.includes(s.id)
          ? { ...s, properties: { ...s.properties, ...payload } }
          : s
      );
    },
 
    setInProgress(state, { payload }) {
      state.inProgress = payload; 
    },

    clearInProgress(state) {
      state.inProgress = null;
    },
  },
});

export const {
  addShape,
  updateShape,
  removeShapes,
  setAllShapes,
  clearAllShapes,
  setSelectedIds,
  toggleSelectedId,
  clearSelection,
  updateSelectedShapes,
  setInProgress,
  clearInProgress,
} = drawingSlice.actions;

export default drawingSlice.reducer;